/**
 * Återställningslänken öppnar `#/aterstall-losenord?token=…`. Token ligger i fragmentet (skickas inte
 * till servern och inte i Referer). Vid start flyttas den till minnet och tas bort ur adressfältet och
 * historiken; den skrivs aldrig till webblagring. Laddas sidan om efter det behövs en ny länk.
 */
export const RESET_HASH = '#/aterstall-losenord';

let token: string | null = null;

export function captureResetToken(loc: Pick<Location, 'hash' | 'pathname' | 'search'> = location, hist: Pick<History, 'replaceState'> = history): boolean {
  if (!loc.hash.startsWith(RESET_HASH)) return false;
  const q = loc.hash.slice(RESET_HASH.length).replace(/^\?/, '');
  const t = new URLSearchParams(q).get('token');
  if (t && /^[A-Za-z0-9_-]{8,200}$/.test(t)) token = t;
  hist.replaceState(null, '', loc.pathname + loc.search + RESET_HASH);
  return true;
}

export function peekResetToken(): string | null {
  return token;
}

/** Tas bort efter lyckat byte så att den inte kan användas igen från den här sidan. */
export function clearResetToken() {
  token = null;
}
